var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfrmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4A4AF4;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.3,
    cy: 441.1,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.3,538.6H77.1l67.3-195h53.1l67.2,195h-44.2l-48.9-150.5h-1.5L121.3,538.6z M118.5,461.9h104.4v32.2H118.5 V461.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.6,538.6v-195h129.1v34h-87.9V424h79.3v34h-79.3v80.6H278.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.8,538.6v-195h76.9c14.7,0,27.3,2.6,37.8,7.9c10.4,5.2,18.4,12.6,23.9,22.2c5.5,9.6,8.2,20.8,8.2,33.7 c0,13-2.8,24.1-8.4,33.4c-5.6,9.3-13.7,16.4-24.2,21.4c-10.6,5-23.3,7.4-38.3,7.4h-51.5v-33.1H495c7.9,0,14.4-1.1,19.6-3.2 c5.2-2.2,9.1-5.4,11.7-9.7c2.6-4.3,3.9-9.7,3.9-16.1c0-6.5-1.3-11.9-3.9-16.4c-2.6-4.4-6.5-7.8-11.7-10.1 c-5.2-2.3-11.8-3.5-19.8-3.5H467v161.3H425.8z M531.1,449.8l48.5,88.8h-45.5l-47.4-88.8H531.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M592.1,343.5H643l53.7,131h2.3l53.7-131h50.9v195h-40V411.6h-1.6l-50.5,126h-27.2l-50.5-126.5h-1.6v127.4h-40 V343.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfrmIcon);
export default __webpack_public_path__ + "static/media/afrm_icon.b3040d603b4f0170b88261f4418705c1.svg";
export { ForwardRef as ReactComponent };